"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "sexta-feira",
    "MONDAY": "Segunda-feira",
    "SATURDAY": "sábado",
    "SUNDAY": "Domigo",
    "THURSDAY": "quinta-feira",
    "TUESDAY": "terça",
    "WEDNESDAY": "quarta-feira",
    "and": "e",
    "day_many": "dias",
    "day_one": "dia",
    "day_other": "dias",
    "day_plural": "dias",
    "freeOfCharge": "Grátis",
    "hour_one": "hora",
    "hour_one_plural": "horas",
    "hour_other": "horas",
    "minute_many": "minuto",
    "minute_one": "minuto",
    "minute_other": "minutos",
    "ocpiRestrictionsAfterDuration": "Após {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Entre {{minDuration}} e {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Primeiro {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Quando o consumo de energia acima de {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Quando o consumo de energia entre {{minKwh}} e {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Quando o consumo de energia for inferior a {{maxKwh}}",
    "session": "sessão",
    "theDay_many": "dia",
    "theDay_one": "dia",
    "theDay_other": "dias",
    "theHour_many": "hora",
    "theHour_one": "hora",
    "theHour_other": "horas",
    "theMinute_many": "minuto",
    "theMinute_one": "minuto",
    "theMinute_other": "minutos"
};
